import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Variáveis de ambiente do Supabase não configuradas!')
  console.error('Crie um arquivo .env com:')
  console.error('VITE_SUPABASE_URL=sua_url_do_supabase')
  console.error('VITE_SUPABASE_ANON_KEY=sua_chave_anonima')
  
  // Em desenvolvimento, usar valores padrão para evitar crash
  if (import.meta.env.DEV) {
    console.warn('⚠️ Usando valores padrão para desenvolvimento')
  } else {
    throw new Error('Faltam as variáveis de ambiente do Supabase')
  }
}

export const supabase = createClient(
  supabaseUrl || 'https://gegzzqgvzjubcplhcxkb.supabase.co',
  supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdlZ3p6cWd2emp1YmNwbGhjeGtiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg2OTY3MTUsImV4cCI6MjA2NDI3MjcxNX0.IQwe2BqkJyGzyTjDnUpE52QR5KM0J3kz8DJMA4owIEE'
)

// Service role (opcional). ATENÇÃO: não exponha em produção.
const supabaseServiceKey = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY
const allowServiceRole = import.meta.env.VITE_ALLOW_SERVICE_ROLE === 'true'

const adminKeyToUse = allowServiceRole && supabaseServiceKey ? supabaseServiceKey : supabaseAnonKey

if (allowServiceRole && supabaseServiceKey) {
  console.warn('⚠️ supabaseAdmin usando SERVICE ROLE KEY (apenas para dev).')
}

export const supabaseAdmin = createClient(
  supabaseUrl || 'https://gegzzqgvzjubcplhcxkb.supabase.co',
  adminKeyToUse,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storage: window.localStorage
    }
  }
)
